// settings for odometer
export const odometerSettings = () => {
  const odometerEls = document.querySelectorAll(
    '[data-odometer-count]',
  ) as NodeListOf<HTMLElement>;

  if (odometerEls.length === 0) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target as HTMLElement;

        // trigger odometer animation
        el.innerText = el.dataset.odometerCount || '0';

        // animate only once
        obs.unobserve(el);
      });
    },
    {
      threshold: 0.5, // adjust if needed
    },
  );
  odometerEls.forEach((el) => observer.observe(el));
};

// data illustration settings
export const dataIllustrationSettings = () => {
  const illustration = document.querySelector(
    '.js-data-illustration',
  ) as HTMLElement;

  if (!illustration) return;

  const illustrationEls = illustration.querySelectorAll(
    '.top__data-illustration-column',
  ) as NodeListOf<HTMLElement>;

  const STAGGER_DELAY = 150; // ms between each bar

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        illustrationEls.forEach((el, index) => {
          const bar = el.querySelector('.bar') as HTMLElement;
          const height = bar.dataset.height;

          setTimeout(() => {
            bar.style.height = `${height}px`;
          }, index * STAGGER_DELAY);
        });

        // Optional: stop observing after first trigger
        observer.disconnect();
      });
    },
    {
      threshold: 0.5,
    },
  );

  illustrationEls.forEach((el) => observer.observe(el));
};
